"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingsPage = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../shared/core");
var components_1 = require("../../../../../shared/core/components");
var analytics_subjects_1 = require("../../../analytics-subjects");
var section_ids_1 = require("../../../section-ids");
var utils_1 = require("../../../utils");
var MeterReadingAnalytics = function (_a) {
    var _b;
    var _c, _d;
    var children = _a.children, selectedFuel = _a.selectedFuel, supplies = _a.supplies;
    var hasGas = (supplies === null || supplies === void 0 ? void 0 : supplies.gas) && ((_c = supplies === null || supplies === void 0 ? void 0 : supplies.gas) === null || _c === void 0 ? void 0 : _c.length) > 0;
    var hasElec = (supplies === null || supplies === void 0 ? void 0 : supplies.electricity) && ((_d = supplies === null || supplies === void 0 ? void 0 : supplies.electricity) === null || _d === void 0 ? void 0 : _d.length) > 0;
    var isDualFuel = hasGas && hasElec;
    var elecMeterCount = (0, utils_1.countMeters)(supplies === null || supplies === void 0 ? void 0 : supplies.electricity);
    var elecSupplyCount = (0, utils_1.countSupplies)(supplies === null || supplies === void 0 ? void 0 : supplies.electricity);
    return (react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.METER_READS_PAGE_CONTENT, properties: (_b = {
                hasGas: hasGas,
                hasElec: hasElec,
                isDualFuel: isDualFuel,
                selectedFuel: selectedFuel,
                elecMeterCount: elecMeterCount,
                elecSupplyCount: elecSupplyCount
            },
            _b[core_1.INTERNAL_EVENT_FLAG] = true,
            _b[analytics_subjects_1.KAPI_ONLY] = true,
            _b) }, children));
};
var MeterReadingsPage = function (_a) {
    var selectedFuel = _a.selectedFuel, children = _a.children, supplies = _a.supplies, rest = __rest(_a, ["selectedFuel", "children", "supplies"]);
    return (
    // eslint-disable-next-line energy-cx/internal-events
    react_1.default.createElement(ui_tools_1.AnalyticsPage, __assign({}, rest),
        react_1.default.createElement(components_1.ErrorBoundary, { id: section_ids_1.METER_READ_PAGE_ERROR },
            react_1.default.createElement(MeterReadingAnalytics, { selectedFuel: selectedFuel, supplies: supplies }, children))));
};
exports.MeterReadingsPage = MeterReadingsPage;
